import React from "react";
import "../styling/Security.css";
import { FaShieldAlt, FaUserShield, FaConciergeBell } from "react-icons/fa";

import eventGuard from "../images/event_guard.jpg";
import bodyGuard from "../images/body_guard.jpg";
import conciergeGuard from "../images/concierge_guard.jpg";

const Security = () => {
  return (
    <><div className=" security dep-card">
      <h3>Security Agency</h3>
      <div className="card">

        {/* Event Security */}
        <div className="service-card">
          <img src={eventGuard} alt="Event Security by VOETA" />
          <div className="service-info">
            <h4><FaShieldAlt />&nbsp; Event Security</h4>
            <p>
              Planning and hosting an event can be overwhelming — but with our Event Security Service, you can focus on enjoying your special day while we handle the safety and security of your guests. As a bonus, we include a professional photographer at no extra cost, ready to capture your event in photos, video, or both — the choice is yours. Whether it’s a wedding, corporate gathering, concert, festival, or any other occasion, our highly trained security personnel ensure a seamless and secure experience from start to finish. In the event of any disruptive behavior, our team uses advanced conflict de-escalation techniques to resolve situations discreetly and professionally, maintaining a safe and comfortable environment for all. Let VOETA take care of your event’s security while you enjoy the moment — and walk away with beautiful memories captured by our photographer.
            </p>
          </div>
        </div>

        {/* Body Guard */}
        <div className="service-card">
          <img src={bodyGuard} alt="Personal Bodyguard by VOETA" />
          <div className="service-info">
            <h4><FaUserShield />&nbsp; Body Guard</h4>
            <p>
              Your safety is our top priority. Our Bodyguard Services provide discreet, highly trained protection specialists dedicated to ensuring your personal security and peace of mind—wherever you go. Whether you're a public figure, executive, celebrity, VIP, or private individual, we tailor our service to your unique security needs and lifestyle. Our bodyguards are professionally trained in personal threat assessment, close protection & surveillance, defensive driving, emergency response & evacuation, and de-escalation and conflict management. We operate with utmost discretion and professionalism, seamlessly integrating into your daily routine or travel plans without disrupting your privacy or comfort. Whether you need short-term protection for an event or long-term private security, VOETA’s Bodyguard Services give you unmatched safety with confidence and class.
            </p>
          </div>
        </div>

        {/* Concierge Guard */}
        <div className="service-card">
          <img src={conciergeGuard} alt="Concierge Guard by VOETA" />
          <div className="service-info">
            <h4><FaConciergeBell />&nbsp; Concierge Guard</h4>
            <p>
              Our Concierge Guard Services combine top-tier security with exceptional hospitality to create a welcoming and secure environment for residents, guests, or clients. Perfect for residential buildings, hotels, corporate offices, and luxury properties, our concierge guards are trained to provide professional front-desk presence while ensuring safety and access control. They greet visitors, manage deliveries, monitor surveillance systems, and respond to incidents with both discretion and authority. Blending customer service excellence with vigilant security measures, our guards act as the first impression of your establishment—polished, respectful, and alert. With VOETA, you get more than security; you get a premium experience tailored to meet the needs of high-end environments and the people within them.
            </p>
          </div>
        </div>

      </div>
    </div>
    
    <style>{`
      .security .dep-card {
    max-width: 1100px;
    padding: 5px;
    margin: 20px auto;
    margin-top: 70px;
  }
  
  .security .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .security .card {
    display: flex;
    flex-wrap: wrap;
    margin: auto;
    max-width: 1100px;
  }
  
  .security .dep-card h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 30px;
  }
  
  .security .service-card {
    background: #ffffff;
    border-radius: 30px;
    padding: 5px;
    margin: 20px;
    border: 1px solid #040404;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s;
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 20px;
    align-items: stretch;
  }
  
  .security .service-card:hover {
    transform: translateY(-5px);
  }
  
  .security .service-card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 20px;
  }
  
  .security .service-card .service-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .security .service-card h4 {
    color: #007bff;
    font-size: 18px;
    margin-bottom: 10px;
  }
  
  .security .service-card p {
    color: #555;
    margin-bottom: 10px;
  }
  
  .security .service-card .cost {
    font-weight: bold;
    color: #28a745;
  }
  
  .security .service-card .cost-details {
    font-size: 14px;
    color: #777;
  }
  
  @media (max-width: 765px) {
    .security .service-card {
      grid-template-columns: 1fr;
      gap: 10px;
    }
  
    .security .container {
      width: 100%;
      max-width: none;
      padding: 20px;
    }
  
    .security .service-card img {
      width: 100%;
      height: 200px;
    }
  
    .security .service-card h4 {
      font-size: 15px;
      text-align: center;
    }
  
    .security .service-card .service-info {
      width: 100%;
      margin-top: 10px;
    }
  }
  `}</style></>
  );
};

export default Security;
